let outterLineLayer, tilesetLayer, tilesetFlat, eventTarget;
let normalShutdown = false; // 标记是否为点击关闭按钮后退出。
export default {
  data() {
    return {
      modelFlattening_show: true,
      flatteningHeightNumber: 0,
      isShowOutterLine: true,
      currentTilesetLayerId: "",
      isFold: false,
    };
  },
  methods: {
    adjustFlatteningHeight(val) {
      if (tilesetFlat) {
        tilesetFlat.updateHeight(val);
      }
    },
    modelFlatteningBox_close() {
      this.removeAll();
      normalShutdown = true;
      this.$emit("modelFlatteningBox_close");
    },
    addRectangle() {
      let cRes = this.checkInfo();
      if (!cRes) {
        return false;
      }

      let that = this;
      this.$GLOBAL.map.graphicLayer.clear();
      this.$GLOBAL.map.graphicLayer.startDraw({
        type: "rectangle",
        style: {
          color: "#007be6",
          opacity: 0.5,
          outline: false,
        },
        success: function(graphic) {
          //绘制成功后回调
          let positions = graphic.getOutlinePositions(false);
          that.$GLOBAL.map.graphicLayer.clear();
          tilesetFlat.addArea(positions, {
            height: that.flatteningHeightNumber,
          });
        },
      });
    },
    addFlatAreaOutterLine(positions) {
      let graphic = new mars3d.graphic.PolylineEntity({
        positions: positions,
        style: {
          closure: true,
          color: "#ffffff",
          opacity: 0.2,
          width: 1,
          clampToGround: true,
        },
      });
      outterLineLayer.addGraphic(graphic);
      return graphic.id;
    },
    onAddFlatArea(event) {
      let areaObj = event.area;
      areaObj.lineId = this.addFlatAreaOutterLine(areaObj.positions);
      // 触发自定义事件 addItem
      eventTarget.fire("addItem", event);
    },
    chkShowOutterLine(val) {
      outterLineLayer.show = val;
    },
    addPolygon() {
      let cRes = this.checkInfo();
      if (!cRes) {
        return false;
      }

      let that = this;
      this.$GLOBAL.map.graphicLayer.clear();
      this.$GLOBAL.map.graphicLayer.startDraw({
        type: "polygon",
        style: {
          color: "#007be6",
          opacity: 0.5,
        },
        success: function(graphic) {
          //绘制成功后回调
          let positions = graphic.positionsShow;
          that.$GLOBAL.map.graphicLayer.clear();
          tilesetFlat.addArea(positions, {
            height: that.flatteningHeightNumber,
          });
        },
      });
    },
    checkInfo() {
      let currentLayerId = window.sessionStorage.getItem("currentLayerId");
      tilesetLayer = this.$GLOBAL.map.getLayerById(currentLayerId);

      if (!tilesetLayer) {
        this.$alert(
          "请先在页面左侧模型目录树里点击您要压平的模型。",
          "友情提示",
          {
            confirmButtonText: "确定",
            type: "warning",
            callback: (action) => {},
          }
        );
        return false;
      }
      //如果切换了模型则更新tilesetFlat。
      if (this.currentTilesetLayerId !== currentLayerId) {
        this.currentTilesetLayerId = currentLayerId;
        if (tilesetFlat && outterLineLayer) {
          outterLineLayer.clear();
          tilesetFlat.clear();
        }
      }
      tilesetFlat = tilesetLayer.flat;
      tilesetFlat.on(mars3d.EventType.addItem, this.onAddFlatArea);
      return true;
    },
    removeAll() {
      if (tilesetFlat) {
        tilesetFlat.clear();
      }
      outterLineLayer.clear();
    },
  },
  mounted() {
    if (!outterLineLayer) {
      outterLineLayer = new mars3d.layer.GraphicLayer();
      this.$GLOBAL.map.addLayer(outterLineLayer);
    }
    outterLineLayer.show = this.isShowOutterLine;
    if (!eventTarget) {
      eventTarget = new mars3d.BaseClass();
    }
  },
  destroyed() {
    if (!normalShutdown) {
      this.removeAll();
    }
    this.$GLOBAL.map.removeLayer(outterLineLayer, true);
    outterLineLayer = null;
    tilesetLayer = null;
    tilesetFlat = null;
  },
  watch: {},
};
